// extracted by mini-css-extract-plugin
export default {"row":"editStore_row__2jK2I","col":"editStore_col__L2VAI","card":"editStore_card__i36Lg"};